export * from './sharefriends.component';
